<template>
  <div>
    <div class="top" id="barId">
      <img src="~@/assets/Home/开放学堂logo.png" alt="" class="topIcon">
      <div class="topText1">开放学堂</div>
      <div class="topText2">学习用卫星遥感办大事的真功夫</div>
      <div class="topText3">面向各层次的遥感地信应用及研发人员的开放课程体系，通过免费学习了解吉林一号在各行业<br>实践应用的基本原理和方法，以学促研、学以致用。</div>
      <div class="topButton1" @click="jumpSignInContent()"></div>
      <div class="topButton2" v-if="!hasSignedIn" @click="judgeSignIn()"></div>
      <div class="topButton2Signed" v-else @click="judgeSignIn()"></div>
      <div class="topText4" v-if="!hasSignedIn">（沈阳/长春/呼和浩特 报名开启中）</div>
    </div>
    <!-- <div class="content1">
      <div class="content1-s">
        <div class="content1Text1">欢迎来到吉林一号遥感开发者培训班！我们将不断为专业用户更新提供满足一切使用吉<br>林一号产品和服务所需储备的系统性课程，以期帮您实现更多业务需求和研发目标。</div>
        <div class="content1Text2">对吉林一号开放学堂有更多期许？或关于课程设计的好点子？ <span style="color:#C49760;cursor: pointer;" @click="linkToFeedback()">我们会认真聆听您的声音 ></span></div>
      </div>
    </div> -->
    <div class="content2">
      <div class="content2-s">
        <div class="content2Text1">吉林一号遥感开发者培训班</div>
        <div class="content2Text2">参加吉林一号的免费线上课堂或免费线下培训，延拓卫星遥感专业知识图谱的同时，让您更了解、更会用吉林一号，与我<br>们一起推动遥感与全行业深入融合，传播生态开放理念</div>
        <div class="content2Shadow">
          <div class="content2Text3">面向群体</div>
          <div class="content2Text4">从事遥感测绘、地理信息及相关专业研发人员及潜在的相关行业从业者</div>
          <div class="content2Text3" style="top: 169px;">学习内容</div>
          <img src="~@/assets/Home/首页培训内容.png" alt="" class="content2Img">
          <div class="content2Text3" style="top: 408px;">学习方式</div>
          <div class="content2Text4" style="top: 452px;">线上自由课堂、线下集中培训 ( 任选 )，统一标准和认证，不收取任何培训费用</div>
          <div class="content2Text3" style="top: 523px;">报名方式</div>
          <div class="content2Text4" style="top: 567px;">线上课堂、线下培训都需提交报名申请，通过审核后方可进行学习</div>
          <div class="content2Text3" style="top:637px;">结业条件</div>
          <div class="content2Text4" style="top: 681px;">线上和线下都需完成全部课程全流程学习并通过相应的学业验收</div>
          <div class="content2Text3" style="top: 751px;">奖励政策</div>
          <div class="content2Text4" style="top: 795px;">对取得结业证书的学员给予商城数据兑换券、开发者认证资格、公司优先实习或录用机会等奖励</div>
        </div>
      </div>
    </div>
    <div class="content5">
      <div class="content5Wrapper">
        <TrainSchedule
          :trainDetail="trainDetail"
          :trainCampList="trainCampList"
          @show-detail="trainDetail=true"
          @hide-detail="trainDetail=false"
          @sign-in="judgeSignIn()"
          @detail-sign-in="detailSignIn"
          @go-result="goResult()"
        />
      </div>
      <!-- <div class="content5Block" v-if="trainDetail">
          <div class="content5Text3" @click="trainDetailItem={};trainDetail=false">&lt; 返回</div>
          <div class="content5Text4">{{ trainDetailItem.name }} · {{ trainDetailItem.region }}<span v-if="trainDetailItem.name.includes('集训营')">站</span><span v-if="!trainDetailItem.name.includes('集训营')">行</span> </div>
          <div class="content5Line1"></div>
          <div class="content5Text5">培训时间</div>
          <div class="content5Text6">
            <span v-if="trainDetailItem.startTime==null">{{ trainDetailItem.date }}</span>
            <span v-else>{{ trainDetailItem.startTime }}-{{ trainDetailItem.endTime }}</span>
          </div>
          <div class="content5Text5" style="top: 263px;">培训地点</div>
          <div class="content5Text6" style="top: 263px;">{{ trainDetailItem.specificRegion }}</div>
          <div class="content5Text5" style="top: 319px;">培训对象</div>
          <div class="content5Text6" style="top: 319px;">从事遥感测绘、地理信息及相关专业的学生、研究人员、行业从业者等</div>
          <div class="content5Text5" style="top: 375px;">课程安排</div>
          <div class="content5Text6" style="top: 375px;line-height: 30px;">涵盖吉林一号星座介绍与产品分级、吉林一号卫星数据处理技术与方法、吉林一号网工具实践等基础类课程，<br> 农业、林业、环保、水利、自然资源、能源、金融等应用类课程以及遥感智能解译等算法类课程。</div>
          <div class="content5Button" @click="judgeSignIn()">立即报名</div>
      </div> -->
    </div>
    <div class="content3">
      <div class="content3Text1">推荐课程</div>
      <div class="content3-s">
          <div class="content3Left" @click="left3Button"></div>
          <div class="content3Right" @click="Right3Button"></div>
          <div class="content3Show">
            <div class="content3Video0" id="content3Video0Id">
              <img src="~@/assets/Home/视频/播放按钮.png" alt="" class="block3Img" id="block3Img0" @click="openVideo(0)" />
            </div>
            <div class="content3Video1" id="content3Video1Id">
              <img src="~@/assets/Home/视频/播放按钮.png" alt="" class="block3Img" id="block3Img1" @click="openVideo(1)" />
            </div>
            <div class="content3Video2" id="content3Video2Id">
              <img src="~@/assets/Home/视频/播放按钮.png" alt="" class="block3Img" id="block3Img2" @click="openVideo(2)" />
            </div>
            <div class="content3Video3" id="content3Video3Id">
              <img src="~@/assets/Home/视频/播放按钮.png" alt="" class="block3Img" id="block3Img3" @click="openVideo(3)" />
            </div>
            <div class="content3Video4" id="content3Video4Id">
              <img src="~@/assets/Home/视频/播放按钮.png" alt="" class="block3Img" id="block3Img4" @click="openVideo(4)" />
            </div>
            <div class="content3Video5" id="content3Video5Id">
              <img src="~@/assets/Home/视频/播放按钮.png" alt="" class="block3Img" id="block3Img5" @click="openVideo(5)" />
            </div>
            <div class="content3Video6" id="content3Video6Id">
              <img src="~@/assets/Home/视频/播放按钮.png" alt="" class="block3Img" id="block3Img6" @click="openVideo(6)" />
            </div>
            <div class="content3Video7" id="content3Video7Id">
              <img src="~@/assets/Home/视频/播放按钮.png" alt="" class="block3Img" id="block3Img7" @click="openVideo(7)" />
            </div>
            <div class="content3Video8" id="content3Video8Id">
              <img src="~@/assets/Home/视频/播放按钮.png" alt="" class="block3Img" id="block3Img8" @click="openVideo(8)" />
            </div>
          </div>
      </div>
      <div class="content3Button1" @click="jumpSignInContent();">查看全部课程</div>
      <div class="content3Line"></div>
    </div>
    <div class="videoShadow" v-if="isVideoPlay"></div>
      <button class="videoClose" id="videoCloseId" @click="videoClose(videoIndex)"></button>
      <video width="1400px" controls="controls" class="movie1" src="~@/assets/Home/视频/典型地物遥感影像特征.mp4" preload="preload"
        id="videoId0"></video>
      <video width="1400px" controls="controls" class="movie1" src="~@/assets/Home/视频/深入了解高分辨遥感卫星.mp4"
        preload="preload" id="videoId1"></video>
      <video width="1400px" controls="controls" class="movie1" src="~@/assets/Home/视频/星地光谱数据获取分析应用.mp4"
        preload="preload" id="videoId2"></video>
      <video width="1400px" controls="controls" class="movie1" src="~@/assets/Home/视频/GIS理论基础.mp4" preload="preload"
        id="videoId3"></video>
      <video width="1400px" controls="controls" class="movie1" src="~@/assets/Home/视频/什么是遥感.mp4" preload="preload"
        id="videoId4"></video>
      <video width="1400px" controls="controls" class="movie1" src="~@/assets/Home/视频/天空地一体化智慧农业应用.mp4"
        preload="preload" id="videoId5"></video>
      <video width="1400px" controls="controls" class="movie1" src="~@/assets/Home/视频/投资统计类项目遥感监管.mp4"
        preload="preload" id="videoId6"></video>
      <video width="1400px" controls="controls" class="movie1" src="~@/assets/Home/视频/卫星遥感在环保领域应用.mp4"
        preload="preload" id="videoId7"></video>
      <video width="1400px" controls="controls" class="movie1" src="~@/assets/Home/视频/遥感目标识别算法及应用.mp4"
        preload="preload" id="videoId8"></video>
    <div class="content4">
      <img src="~@/assets/Home/首页联系我们.png" alt="" class="content3Img" style="top: 99px;">
      <div class="content3Text3" style="top: 327px;">仍有困惑？我们很乐于帮忙！</div>
      <div class="content3Text4" style="top: 392px;">对吉林一号遥感开发者培训班的任何内容有疑问? 我们的教育团队会提供帮助。</div>
      <div class="content3Button2" style="top: 450px;" @click="connectStatus=true">联系我们</div>
    </div>
    <div class="shadow" v-if="connectStatus">
      <div class="dialog2" >
          <img src="~@/assets/newHome/关闭.png" alt="" class="dialogImg1" @click="connectStatus=false"/>
          <img src="https://market.obs.cn-north-4.myhuaweicloud.com/jl1mall/lianxiren.png" alt="" class="dialogImg4" />
              <div class="guanwang" @click="goGuanwang()"></div>
      </div>
    </div>
<!--    <div class="shadow" v-if="shadow == 1">-->
<!--      <div class="shadowWhite">-->
<!--        <div class="text4">很抱歉！</div>-->
<!--        <div class="text5">-->
<!--          吉林一号遥感开发者培训班 · 长春站{{trainStatus}}，如有其他问题请联系我们的教育专员。-->
<!--          <br />0431-86008580 (工作日工作时)-->
<!--        </div>-->
<!--        <div class="shadowButton" @click="shadow=0">关闭</div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="shadow" v-if="shadow == 2">-->
<!--      <div class="shadowWhite">-->
<!--        <div class="text4" style="top: 60px;">提示</div>-->
<!--        <div class="text5" style="top: 120px;">-->
<!--          您已成功报名吉林一号遥感开发者培训班 · 长春站-->
<!--        </div>-->
<!--        <div class="shadowButton" @click="shadow=0">关闭</div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="shadow" v-if="shadow == 3">-->
<!--      <div class="shadowWhite">-->
<!--        <div class="text4">很抱歉！</div>-->
<!--        <div class="text5" style="text-align: center;">-->
<!--          您未通过报名审核。如有问题请联系我们的教育专员。-->
<!--          <br />0431-86008580 (工作日工作时)-->
<!--        </div>-->
<!--        <div class="shadowButton" @click="shadow=0">关闭</div>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
import {rootUrl} from '@/globalConfig'
import TrainSchedule from '@/components/TrainSchedule'
export default {
  name: "Home",
  components: { TrainSchedule },
  data() {
    return {
      timerVideo:'',
      zIndex:[-1,1,2,3,4,3,2,1,-1],
      block: [
        "none",
        "none",
        "none",
        "none",
        "block",
        "none",
        "none",
        "none",
        "none",
      ],
      positionT:[70,70,50,20,0,20,50,70,70],
      positionL:[-30,0,81,190,370,610,820,950,1120],
      sizeW:[270,270,330,420,480,420,330,270,270],
      sizeY:[180,180,220,280,320,280,220,180,180],
      numberNow:0,
      isVideoPlay: false,
      leftButton:false,
      rightButton:false,
      connectStatus:false,
      trainCampList:[],
      trainDetail:false,
      trainDetailItem:{},
      //判断报名是否已截止
      signInPermit:0,
      shadow:0,
      trainStatus:'',
      //判断用户线下报名状态0：未报名、1：审核中、2：通过、3：驳回
      offlineStatus:0,
      //是否已报名（signInStatus!=='未报名'）
      hasSignedIn:false,
    };
  },
  methods: {
    linkToFeedback(){
      let url = "/Feedback";
      if (this.$store.state.user.logined){
        window.open("http://jl1mall.com/store/feedback","_self");
      }else{
        window.open("http://jl1mall.com/Login?returnUrl=" + url,"_self");
      }
      // window.open("http://10.200.28.22:8081/Feedback"); //打开一个新的标签页
    },
    getKey() {
      return localStorage.getItem("token");
    },
    //带权限判断的跳转
    jumpWithPermission(type,path,fromUrl){
        //path:需要跳转到的路由；fromUrl：如果权限不满足，满足后回跳的路由
        //注意：fromUrl必须为包含本项目router中base的相对地址，如商城个人中心为：/store/UserCenter
        let loginUserId=localStorage.getItem('userId');//是否已登录
        let authentication=localStorage.getItem('authentication');//0:已实名；1：未实名
        if(type=='可游客'){
          if(fromUrl){
            window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
          }
          else {
            window.open(rootUrl+path,"_self")
          }
        }else if(type=='仅登录'){
          //已登录
          if(loginUserId){
            if(fromUrl){
              window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
            }
            else {
              window.open(rootUrl+path,"_self")
            }
          }
          //未登录
          else {
            if(fromUrl){
              window.open(rootUrl+'/Login'+"?fromUrl="+rootUrl+fromUrl,"_self")
            }
            else {
              window.open(rootUrl+'/Login',"_self")
            }
          }
        }else if(type=='仅实名'){
          //已登录
          if(loginUserId){
            //已实名
            if(authentication=='0'){
              if(fromUrl){
                window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
              }
              else {
                window.open(rootUrl+path,"_self")
              }
            }
            //未实名
            else {
              window.open(rootUrl+'/Authentication',"_self")
            }

          }
          //未登录
          else {

            if(fromUrl){
              window.open(rootUrl+'/Login'+"?fromUrl="+rootUrl+fromUrl,"_self")
              // this.$router.push('/Login')
            }
            else {
              window.open(rootUrl+'/Login',"_self")
            }
          }
        }
      },
    //实名权限检查与处理（培训班版）
    checkAndHandleAuthentication(){
        console.log("进入实名检查")
        let loginUserId=localStorage.getItem('userId');//是否已登录
        let authentication=localStorage.getItem('authentication');//0:已实名；1：未实名
        if(!loginUserId){
          this.jumpWithPermission('仅登录','/Login','/learn/')
        }
        else if(authentication!='0'){
          this.jumpWithPermission('仅实名','/Authentication','/learn/offlineSignIn')
      }
      return true;
    },
    left3Button() {
      this.numberNow--;
      this.cartoonRun();
    },
    Right3Button() {
      this.numberNow++;
      this.cartoonRun();
    },
    cartoonRun() {
      let n = this.numberNow;
      while (n < 0) {
        n = n + 9;
      }
      let n0 = n % 9;
      let n1 = (n + 1) % 9;
      let n2 = (n + 2) % 9;
      let n3 = (n + 3) % 9;
      let n4 = (n + 4) % 9;
      let n5 = (n + 5) % 9;
      let n6 = (n + 6) % 9;
      let n7 = (n + 7) % 9;
      let n8 = (n + 8) % 9;

      let content3Video0Id = document.getElementById("content3Video0Id");
      let content3Video1Id = document.getElementById("content3Video1Id");
      let content3Video2Id = document.getElementById("content3Video2Id");
      let content3Video3Id = document.getElementById("content3Video3Id");
      let content3Video4Id = document.getElementById("content3Video4Id");
      let content3Video5Id = document.getElementById("content3Video5Id");
      let content3Video6Id = document.getElementById("content3Video6Id");
      let content3Video7Id = document.getElementById("content3Video7Id");
      let content3Video8Id = document.getElementById("content3Video8Id");
      let block3Img0 = document.getElementById("block3Img0");
      let block3Img1 = document.getElementById("block3Img1");
      let block3Img2 = document.getElementById("block3Img2");
      let block3Img3 = document.getElementById("block3Img3");
      let block3Img4 = document.getElementById("block3Img4");
      let block3Img5 = document.getElementById("block3Img5");
      let block3Img6 = document.getElementById("block3Img6");
      let block3Img7 = document.getElementById("block3Img7");
      let block3Img8 = document.getElementById("block3Img8");

      content3Video0Id.style.zIndex = this.zIndex[n0];
      content3Video0Id.style.top = this.positionT[n0] + "px";
      content3Video0Id.style.left = this.positionL[n0] + "px";
      content3Video0Id.style.width = this.sizeW[n0] + "px";
      content3Video0Id.style.height = this.sizeY[n0] + "px";
      block3Img0.style.display = this.block[n0];

      content3Video1Id.style.zIndex = this.zIndex[n1];
      content3Video1Id.style.top = this.positionT[n1] + "px";
      content3Video1Id.style.left = this.positionL[n1] + "px";
      content3Video1Id.style.width = this.sizeW[n1] + "px";
      content3Video1Id.style.height = this.sizeY[n1] + "px";
      block3Img1.style.display = this.block[n1];

      content3Video2Id.style.zIndex = this.zIndex[n2];
      content3Video2Id.style.top = this.positionT[n2] + "px";
      content3Video2Id.style.left = this.positionL[n2] + "px";
      content3Video2Id.style.width = this.sizeW[n2] + "px";
      content3Video2Id.style.height = this.sizeY[n2] + "px";
      block3Img2.style.display = this.block[n2];

      content3Video3Id.style.zIndex = this.zIndex[n3];
      content3Video3Id.style.top = this.positionT[n3] + "px";
      content3Video3Id.style.left = this.positionL[n3] + "px";
      content3Video3Id.style.width = this.sizeW[n3] + "px";
      content3Video3Id.style.height = this.sizeY[n3] + "px";
      block3Img3.style.display = this.block[n3];

      content3Video4Id.style.zIndex = this.zIndex[n4];
      content3Video4Id.style.top = this.positionT[n4] + "px";
      content3Video4Id.style.left = this.positionL[n4] + "px";
      content3Video4Id.style.width = this.sizeW[n4] + "px";
      content3Video4Id.style.height = this.sizeY[n4] + "px";
      block3Img4.style.display = this.block[n4];

      content3Video5Id.style.zIndex = this.zIndex[n5];
      content3Video5Id.style.top = this.positionT[n5] + "px";
      content3Video5Id.style.left = this.positionL[n5] + "px";
      content3Video5Id.style.width = this.sizeW[n5] + "px";
      content3Video5Id.style.height = this.sizeY[n5] + "px";
      block3Img5.style.display = this.block[n5];

      content3Video6Id.style.zIndex = this.zIndex[n6];
      content3Video6Id.style.top = this.positionT[n6] + "px";
      content3Video6Id.style.left = this.positionL[n6] + "px";
      content3Video6Id.style.width = this.sizeW[n6] + "px";
      content3Video6Id.style.height = this.sizeY[n6] + "px";
      block3Img6.style.display = this.block[n6];

      content3Video7Id.style.zIndex = this.zIndex[n7];
      content3Video7Id.style.top = this.positionT[n7] + "px";
      content3Video7Id.style.left = this.positionL[n7] + "px";
      content3Video7Id.style.width = this.sizeW[n7] + "px";
      content3Video7Id.style.height = this.sizeY[n7] + "px";
      block3Img7.style.display = this.block[n7];

      content3Video8Id.style.zIndex = this.zIndex[n8];
      content3Video8Id.style.top = this.positionT[n8] + "px";
      content3Video8Id.style.left = this.positionL[n8] + "px";
      content3Video8Id.style.width = this.sizeW[n8] + "px";
      content3Video8Id.style.height = this.sizeY[n8] + "px";
      block3Img8.style.display = this.block[n8];
    },
    openVideo(i) {
      this.isVideoPlay = true;
      this.videoIndex = i;
      this.isVedioPlay = true;
      let videoId = document.getElementById("videoId" + i);
      videoId.style.zIndex = "10001";
      let videoCloseId = document.getElementById("videoCloseId");
      videoCloseId.style.zIndex = "10002";
      videoId.play();
    },
    videoClose(i) {
      this.isVideoPlay = false;
      let videoId = document.getElementById("videoId" + i);
      videoId.style.zIndex = "-1";
      let videoCloseId = document.getElementById("videoCloseId");
      videoCloseId.style.zIndex = "-2";
      videoId.pause();
      this.isVedioPlay = false;
    },
    refreshLocation() {
      // location.reload();
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant",
      });
    },
    goGuanwang(){
        window.open("http://www.jl1.cn/")
    },
    getCampList(){
       this.axios.get("/learn_back/course/register/getCampList", {
        headers: {
          Authorization: "Bearer " + this.getKey(),
        },
      })
      .then((res) => {
        this.trainCampList=res.data.data.trainCampList
        console.log('[getCampList] trainCampList=', JSON.stringify(this.trainCampList))
        this.hasSignedIn = this.trainCampList.some(item => item.signInStatus !== '未报名')
        console.log('[getCampList] hasSignedIn=', this.hasSignedIn)
        this.trainStatus=this.trainCampList[0].trainStatus
        if(this.trainCampList[0].trainStatus=='名额已满'||this.trainCampList[0].trainStatus=='报名已截止'){
          this.signInPermit=1
        }
      })
    },
    getOfflineStatus(){
      this.axios.get("/learn_back/course/register/getOfflineStatus?qs=13", {
        headers: {
          Authorization: "Bearer " + this.getKey(),
        },
      })
      .then((res) => {
        this.offlineStatus=res.data.data
      })
    },
    judgeSignIn(){
      if(this.checkAndHandleAuthentication()){
        // 立即报名直接跳报名页;已报名则查看报名结果
        this.$router.push(this.hasSignedIn ? '/offlineResult' : '/offlineSignIn')
      }
    },
    goResult(){
      this.$router.push('/offlineResult')
    },
    goTrainDetail(item){
      this.trainDetailItem = item
      this.trainDetail=true
    },
    // 查看详细课程安排内「立即报名」:跳转 offlineSignIn 并携带当前期数 qs
    detailSignIn(qs){
      if(this.checkAndHandleAuthentication()){
        this.$router.push({ path: '/offlineSignIn', query: { qs: qs } })
      }
    },
    jumpSignInContent(){
      // 线上课堂需登录：已登录则 SPA 内正常跳转；未登录跳转登录页，登录成功回跳首页
      let loginUserId = localStorage.getItem('userId');
      if (loginUserId) {
        this.$router.push('/globalCourse')
      } else {
        this.jumpWithPermission('仅登录','/Login','/learn')
      }
    },
  },
  mounted() {
    document.getElementById('barId').scrollIntoView({ behavior: "instant"});
    this.getCampList()
    this.getOfflineStatus()
  },
  computed: {

    
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
a {
  text-decoration: none;
}
.top{
  position: relative;
  margin-top: 0;
  width: 100%;
  height:800px;
  background-position: center;
  background-size: cover;
  background-image: url(~@/assets/Home/首页背景图.png);

}
.top1{
  position: relative;
  margin-top: 0;
  width: 100vw;
  height: 700px;
  background-image: url(~@/assets/Home/北京行.png);
  background-size: 100% 100%;

}
.topIcon{
  position: absolute;
  top: 201px;
  left: calc(50% - 34px);
  width: 68px;
  height: 52px;
}
.topText1{
  position: absolute;
  top: 268px;
  left: calc(50% - 640px);
  width: 1280px;
  height: 24px;
  font-size: 20px;
font-family: Tensentype-ZhiHeiJ-W4, Tensentype-ZhiHeiJ;
font-weight: normal;
color: #FFFFFF;
line-height: 24px;
  text-align: center;
}
.topText2{
  position: absolute;
  top: 322px;
  left: calc(50% - 300px);
  width: 600px;
  height: 42px;
font-size: 30px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 600;
color: #FFFFFF;
line-height: 42px;
  text-align: center;
}
.topText3{
  position: absolute;
  top: 384px;
  left: calc(50% - 640px);
  width: 1280px;
  height: 60px;
font-size: 18px;
font-family: PingFangSC-Light, PingFang SC;
font-weight: 300;
color: rgba(255,255,255,0.7);
line-height: 30px;
text-align: center;
}
.topText4{
  position: absolute;
  top: 551px;
  left: calc(50% - 21.5px);
  width:auto;
  height: 60px;
  font-size: 15px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: rgba(255,255,255,0.7);
  line-height: 30px;
  text-align: center;
}
.topButton{
  position: absolute;
  top: 493px;
  left: calc(50% - 81px);
  width: 162px;
  height: 56px;
  cursor: pointer;
  background-image: url('~@/assets/Home/开始学习白.png');
  background-size: 100% 100%;
}
.topButton:hover{
  background-image: url('~@/assets/Home/开始学习黑.png');
  background-size: 100% 100%;
}
.topButton1{
  position: absolute;
  top: 493px;
  left: calc(50% - 192px);
  width: 182px;
  height: 56px;
  cursor: pointer;
  background-image: url('~@/assets/Home/进入线上课堂1.png');
  background-size: 100% 100%;
  transition: 0.5s;
}
.topButton1:hover{
  background-image: url('~@/assets/Home/进入线上课堂.png');
  background-size: 100% 100%;
}
.topButton2{
  position: absolute;
  top: 493px;
  left: calc(50% + 10px);
  width: 182px;
  height: 56px;
  cursor: pointer;
  background-image: url('~@/assets/Home/预约报名线下1.png');
  background-size: 100% 100%;
  transition: 0.5s;
}
.topButton2:hover{
  background-image: url('~@/assets/Home/预约报名线下.png');
  background-size: 100% 100%;
}
.topButton2Signed{
  position: absolute;
  top: 493px;
  left: calc(50% + 10px);
  width: 182px;
  height: 56px;
  cursor: pointer;
  background-image: url('~@/assets/Home/已报名_default.png');
  background-size: 100% 100%;
  transition: 0.5s;
}
.topButton2Signed:hover{
  background-image: url('~@/assets/Home/已报名_hover.png');
  background-size: 100% 100%;
}
.content1{
  position: relative;
  width: 100%;
  height: 340px;
background: #FFFFFF;
}
.content1-s{
  position: absolute;
  width: 1920px;
  height: 340px;
  left: calc(50% - 960px);
}
.content1Text1{
  position: absolute;
  top: 100px;
  left: calc(50% - 500px);
  width: 1000px;
height: 82px;
font-size: 26px;
font-family: PingFangSC-Medium, PingFang SC;
font-weight: 500;
color: #363F53;
line-height: 42px;
text-align: center;
}
.content1Text2{
  position: absolute;
  top: 222px;
  left: calc(50% - 500px);
  width: 1000px;
height: 18px;
font-size: 18px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #363F53;
line-height: 18px;
text-align: center;
}
.content2{
  position: relative;
  margin-top: -1px;
  width: 100%;
  height:1258px;
  background: url("~@/assets/Home/培训班介绍背景图.png") no-repeat;
  background-position: center;
  background-size: cover;
}
.content2-s{
  position: absolute;
  left: calc(50% - 960px);
  width: 1920px;
height: 1400px;
}
.content2Text1{
  position: absolute;
  top: 100px;
  left: calc(50% - 156px);
  width: 312px;
height: 31px;
font-size: 26px;
font-family: Tensentype-ZhiHeiJ-W4, Tensentype-ZhiHeiJ;
font-weight: normal;
color: #FFFFFF;
line-height: 31px;
text-align: center;
}
.content2Text2{
  position: absolute;
  top: 158px;
  left: calc(50% - 480px);
  width: 960px;
height: 64px;
font-size: 18px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #FFFFFF;
line-height: 32px;
text-align: center;
}
.content2Shadow{
  position: absolute;
  top: 275px;
  left: calc(50% - 640px);
  width: 1280px;
height: 888px;
background: rgba(112,135,190,0.2);
border-radius: 16px;
}
.content2Text3{
  position: absolute;
  top: 57px;
  left: calc(50% - 640px);
  width: 1280px;
  height: 22px;
font-size: 20px;
font-family: Tensentype-ZhiHeiJ-W4, Tensentype-ZhiHeiJ;
font-weight: normal;
color: #FFFFFF;
line-height: 22px;
text-shadow: 2px 2px 10px rgba(0,0,0,0.5);
text-align: center;
}
.content2Text4{
  position: absolute;
  top: 99px;
  left: calc(50% - 640px);
  width: 1280px;
  height: 25px;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 25px;
  text-align: center;
}
.content2Img{
  position: absolute;
  top: 218px;
  width: 1190px;
  height: 150px;
  left: calc(50% - 595px);
}
.content2Button{
  position: absolute;
  top: 858px;
  left: 600px;
  width: 85px;
height: 25px;
font-size: 18px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 600;
color: #C49760;
line-height: 25px;
text-shadow: 0px 0px 5px rgba(0,0,0,0.5);
text-align: left;
cursor: pointer;
}
.content2Img2{
position: absolute;
top: 5px;
left: 80px;
width: 8px;
height: 14px;
}
.signInButton{
  position: absolute;
  top: 1000px;
  left: calc(50% - 81px);
  width: 162px;
height: 56px;
border-radius: 22px;
background: url("~@/assets/Home/立即报名_default.png") no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
}
.signInButton:hover{
background: url("~@/assets/Home/立即报名_hover.png") no-repeat;
background-size: 100% 100%;
}
.content3{
  position: relative;
  width: 100%;
  height: 700px;
  background-color: #000000;
}
.content3-s {
  position: absolute;
  top:90px;
  width: 1280px;
  height: 435px;
  left: calc(50% - 640px);
  /* background-color: pink; */
}
.content3Button1{
  position: absolute;
  top: 556px;
  left: calc(50% - 75px);
  width: 150px;
  height: 44px;
  border-radius: 22px;
  border: 1px solid #FFFFFF;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
  line-height: 44px;
  text-align: center;
  cursor: pointer;
}
.content3Line{
  position: absolute;
  top: 699px;
  left: calc(50% - 640px);
  width: 1280px;
  height: 1px;
  border-top: 1px solid rgba(255,255,255,0.3);
}
.content3Text1{
  position: absolute;
  top: 100px;
  left: calc(50% - 640px);
  width: 1280px;
height: 30px;
font-size: 26px;
font-family: Tensentype-ZhiHeiJ-W4, Tensentype-ZhiHeiJ;
font-weight: normal;
color: #FFFFFF;
line-height: 30px;
text-align: center;
}
.content3Left{
  position: absolute;
  top: 228px;
  left: 0px;
  width: 16px;
height: 24px;
background: url("~@/assets/Home/向左切换白.png") no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
}
.content3LeftHover{
  position: absolute;
  top: 328px;
  left: 0px;
  width: 16px;
height: 24px;
background: url("~@/assets/Home/向左切换金.png") no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
}
.content3Right{
  position: absolute;
  top: 228px;
  right: 0px;
  width: 16px;
height: 24px;
background: url("~@/assets/Home/向右切换白.png") no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
}
.content3RightHover{
  position: absolute;
  top: 328px;
  right: 0px;
  width: 16px;
height: 24px;
background: url("~@/assets/Home/向右切换金.png") no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
}
.content3Show{
  position: absolute;
  top: 80px;
  left: calc(50% - 610px);
  width: 1220px;
  height: 320px;
  /* background-color: rebeccapurple; */
  overflow: hidden;
}
.content3Video4 {
  position: absolute;
  top: 0px;
  left: 370px;
  width: 480px;
  height: 320px;
  background-image: url(~@/assets/Home/视频/什么是遥感.png);
  background-size: 100% 100%;
  z-index: 4;
  transition: 0.5s;
}
.content3Video3 {
  position: absolute;
  top: 20px;
  left: 190px;
  width: 420px;
  height: 280px;
  background-image: url(~@/assets/Home/视频/GIS理论基础.png);
  background-size: 100% 100%;
  z-index: 3;
  transition: 0.5s;
}
.content3Video5 {
  position: absolute;
  top: 20px;
  left: 610px;
  width: 420px;
  height: 280px;
  background-image: url(~@/assets/Home/视频/天空地一体化智慧农业应用.png);
  background-size: 100% 100%;
  z-index: 3;
  transition: 0.5s;
}
.content3Video2 {
  position: absolute;
  top: 50px;
  left: 81px;
  width: 330px;
  height: 220px;
  background-image: url(~@/assets/Home/视频/星地光谱数据获取分析与应用.png);
  background-size: 100% 100%;
  z-index: 2;
  transition: 0.5s;
}
.content3Video6 {
  position: absolute;
  top: 50px;
  left: 820px;
  width: 330px;
  height: 220px;
  background-image: url(~@/assets/Home/视频/投资统计类项目遥感监管.png);
  background-size: 100% 100%;
  z-index: 2;
  transition: 0.5s;
}
.content3Video1 {
  position: absolute;
  top: 70px;
  left: 0px;
  width: 270px;
  height: 180px;
  background-image: url(~@/assets/Home/视频/深入了解高分辨遥感卫星.png);
  background-size: 100% 100%;
  z-index: 1;
  transition: 0.5s;
}
.content3Video0 {
  position: absolute;
  top: 70px;
  left: -30px;
  width: 270px;
  height: 180px;
  background-image: url(~@/assets/Home/视频/典型地物遥感影像特征.png);
  background-size: 100% 100%;
  /* background-color: palegoldenrod; */
  z-index: -1;
  transition: 0.5s;
}
.content3Video7 {
  position: absolute;
  top: 70px;
  left: 950px;
  width: 270px;
  height: 180px;
  background-image: url(~@/assets/Home/视频/卫星遥感在环保领域应用.png);
  background-size: 100% 100%;
  z-index: 1;
  transition: 0.5s;
}
.content3Video8 {
  position: absolute;
  top: 70px;
  left: 1120px;
  width: 270px;
  height: 180px;

  background-image: url(~@/assets/Home/视频/遥感目标识别算法及应用.png);
  background-size: 100% 100%;
  /* background-color: pink; */
  z-index: -1;
  transition: 0.5s;
}
.block3Img {
  position: absolute;
  width: 62px;
  height: 62px;
  bottom: 20px;
  right: 20px;
  cursor: pointer;
  z-index: 10;
  display: block;
}
.videoShadow {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 10000;
  background: rgba(0, 0, 0, 0.5);
}

.videoClose {
  position: fixed;
  width: 30px;
  height: 30px;
  top: calc(50% - 390px);
  left: calc(50% + 655px);
  background-image: url("~@/assets/Home/视频/关闭.png");
  background-size: 30px 30px;
  z-index: -2;
  border: 0;
}

.movie1 {
  position: fixed;
  width: 1400px;
  top: calc(50% - 400px);
  left: calc(50% - 700px);
  z-index: -1;
}
.content3Button{
  position: absolute;
  top: 556px;
  left: calc(50% - 75px);
  width: 150px;
height: 44px;
background: #FFFFFF;
border-radius: 22px;
border: 1px solid #C49760;
font-size: 16px;
font-family: PingFangSC-Medium, PingFang SC;
font-weight: 500;
color: #C49760;
line-height: 44px;
text-align: center;
cursor: pointer;
}
.content3Button:hover{
  background: #C49760;
border: 1px solid #C49760;
color: #FFFFFF;
}
.content3Line1{
  position: absolute;
  top: 700px;
  left: calc(50% - 640px);
  width: 1280px;
height: 1px;
background-color: rgba(0,0,0,0.15);
}
.content3Text2{
  position: absolute;
  top: 801px;
  left: calc(50% - 90px);
  width: 180px;
height: 30px;
font-size: 26px;
font-family: Tensentype-ZhiHeiJ-W4, Tensentype-ZhiHeiJ;
font-weight: normal;
color: #363F53;
line-height: 30px;
text-align: center;
}
.content3Block{
  position: absolute;
  width: 108px;
height: 100px;
top: 876px;
left: 0px;
}
.content3Line2{
  position: absolute;
 right: 0;
  top: 924px;
  width: 1150px;
height: 1px;
background:  rgba(196,151,96,0.5);
}
.year2021{
  position: absolute;
  top: 883px;
  left: 130px;
  width: 62px;
height: 30px;
font-size: 26px;
font-family: Arial-Black, Arial;
font-weight: 900;
color: #C49760;
line-height: 30px;
text-align: left;
cursor: pointer;
}
.year2021-s{
  position: absolute;
  top: 883px;
  left: 130px;
  width: 62px;
height: 30px;
font-size: 26px;
font-family: Arial-Black, Arial;
font-weight: 900;
color: #363F53;
line-height: 30px;
text-align: left;
cursor: pointer;
}
.month1{
position: absolute;
top: 883px;
left: 590px;
width:44px;
height: 30px;
font-size: 26px;
font-family: Arial-Black, Arial;
font-weight: 900;
color: #C49760;
line-height: 30px;
text-align: right;
cursor: pointer;
}
.month1-s{
position: absolute;
top: 883px;
left: 590px;
width:44px;
height: 30px;
font-size: 26px;
font-family: Arial-Black, Arial;
font-weight: 900;
color: #363F53;
line-height: 30px;
text-align: right;
cursor: pointer;
}
.day1{
  position: absolute;
  top: 948px;
  left: 136px;
  width: 30px;
height: 30px;
font-size: 24px;
font-family: ArialNarrow-Bold, ArialNarrow;
font-weight: bold;
color: #C49760;
line-height: 30px;
text-align: center;
}
.content3Button2{
  position: absolute;
  top: 1061px;
  left: calc(50% - 64px);
  width: 128px;
height: 44px;
border-radius: 22px;
border: 1px solid #FFFFFF;
font-size: 16px;
font-family: PingFangSC-Medium, PingFang SC;
font-weight: 500;
color: #FFFFFF;
line-height: 44px;
text-align: center;
cursor: pointer;
}
.content3Line3{
  position: absolute;
  top: 1205px;
  left: calc(50% - 640px);
  width: 1280px;
height: 1px;
background:rgba(0,0,0,0.15);
}
.content3Img{
  position: absolute;
  width: 600px;
height: 200px;
top: 805px;
left: calc(50% - 300px);
}
.content3Text3{
  position: absolute;
  top: 1050px;
  left: calc(50% - 170px);
  width: 340px;
height: 37px;
font-size: 26px;
font-family: PingFangSC-Medium, PingFang SC;
font-weight: 500;
color: #fff;
line-height: 37px;
text-align: center;
}
.content3Text4{
position: absolute;
top: 1100px;
left: calc(50% - 400px);
width: 800px;
height: 18px;
font-size: 18px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #fff;
line-height: 18px;
text-align: center;
}
.content4{
  position: relative;
  width: 100%;
  height: 650px;
background: #000;
}
.dialog2 {
    position: absolute;
  width: 600px;
  height: 400px;
  border-radius: 16px;
  left: calc(50% - 300px);
  top: calc(50% - 200px);
  z-index: 10001;
  background: #ffffff;
}
.dialogImg1{
    position: absolute;
    top: 0;
    right: -50px;
    cursor: pointer;
}
.dialogImg4 {
position: absolute;
width: 505px;
height: 306px;
top: calc(50% - 153px);
left: calc(50% - 252px);
}
.guanwang{
  position: absolute;
  /* background-color: pink; */
  width: 100px;
  height: 20px;
  top: 277px;
  left: 440px;
  cursor: pointer;
}
.dialogText1 {
    position: absolute;
  top: 69px;
  left: calc(50% - 300px);
  width: 600px;
  height: 24px;
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #1d1d28;
  line-height: 25px;
  text-align: center;
}
.dialogImg2{
    position: absolute;
    left: 156px;
    top: 144px;
}
.dialogText2 {
 position: absolute;
 top: 140px;
  left: 190px;
  width: 300px;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #1d1d28;
  line-height: 22px;
}
.dialogText3 {
    position: absolute;
    top: 165px;
    left: 190px;
  width: 208px;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #1d1d28;
  line-height: 22px;
  text-align: center;
}
.dialogText4 {
position: absolute;

top: 214px;
    left: 190px;
  width: 120px;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #1d1d28;
  line-height: 22px;
}
.hideToConsultation {
position: absolute;
left: calc(50% - 48px);
top: 300px;
  width: 96px;
  height: 44px;
  background: #1E81EB;
  border-radius: 22px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  line-height: 44px;
  text-align: center;
  cursor: pointer;
}
.shadow{
  position: fixed;
  top: 0;
  width: 100%;
  height:100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 10000;
}

</style>
<style scoped>
.content5{
  position: relative;
  width: 100%;
  height: 816px;
  background: #000000;
}
.content5Wrapper{
  position: absolute;
  top: 100px;
  left: calc(50% - 640px);
}
.content5Text3{
  position: absolute;
  width: 50px;
  height: 16px;
  top: 50px;
  left: 50px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 16px;
  text-align: right;
  cursor: pointer;
}
.content5Text4{
  position: absolute;
  top: 79px;
  width: 1280px;
height: 28px;
font-family: Tensentype-ZhiHeiJ, Tensentype-ZhiHeiJ;
font-weight: normal;
font-size: 26px;
color: #FFFFFF;
line-height: 28px;
text-align: center;
}
.content5Line1{
  position: absolute;
  top: 157px;
  left: 215px;
  width: 870px;
height: 1px;
border-top: 1px solid rgba(255,255,255,0.2);
}
.content5Text5{
  position: absolute;
  top: 207px;
  left: 215px;
  width: auto;
  height: 16px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 300;
  font-size: 16px;
  color: rgba(255,255,255,0.6);
  line-height: 16px;
}
.content5Text6{
  position: absolute;
  top: 207px;
  left: 310px;
  width:774px;
  height: auto;
font-family: PingFangSC, PingFang SC;
font-weight: 400;
font-size: 16px;
color: #FFFFFF;
line-height: 16px;
}
.shadowWhite {
  position: absolute;
  top: calc(50% - 150px);
  left: calc(50% - 300px);
  width: 600px;
  height: 300px;
  background: #ffffff;
  border-radius: 16px;
}
.text4 {
  position: absolute;
  top: 30px;
  left: calc(50% - 300px);
  width: 600px;
  height: 28px;
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #3a3a3a;
  line-height: 28px;
  text-align: center;
}
.text5 {
  position: absolute;
  top: 90px;
  left: calc(50% - 250px);
  width: 500px;
  height: 324px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #3a3a3a;
  line-height: 36px;
}
.shadowButton {
  position: absolute;
  top: 230px;
  left: calc(50% - 48px);
  width: 96px;
  height: 44px;
  background: #c49760;
  border-radius: 22px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 44px;
  text-align: center;
  cursor: pointer;
}
</style>
